'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.resetCreateApplication = resetCreateApplication;
exports.createApplication = createApplication;
exports.loadApplications = loadApplications;
exports.loadApplication = loadApplication;
exports.deleteApplication = deleteApplication;
exports.loadAuthorisedApplications = loadAuthorisedApplications;
exports.revokeApplication = revokeApplication;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLICATION_CREATE_INIT = 'ms/application/create_init';
var APPLICATION_CREATE = 'ms/application/create';
var APPLICATION_CREATE_SUCCESS = 'ms/application/create_success';
var APPLICATION_CREATE_FAIL = 'ms/application/create_fail';

var APPLICATION_LOAD_ALL = 'ms/application/load_all';
var APPLICATION_LOAD_ALL_SUCCESS = 'ms/application/load_all_success';
var APPLICATION_LOAD_ALL_FAIL = 'ms/application/load_all_fail';

var APPLICATION_LOAD = 'ms/application/load';
var APPLICATION_LOAD_SUCCESS = 'ms/application/load_success';
var APPLICATION_LOAD_FAIL = 'ms/application/load_fail';

var APPLICATION_DELETE = 'ms/application/delete';
var APPLICATION_DELETE_SUCCESS = 'ms/application/delete_success';
var APPLICATION_DELETE_FAIL = 'ms/application/delete_fail';

var APPLICATION_REVOKE = 'ms/application/revoke';
var APPLICATION_REVOKE_SUCCESS = 'ms/application/revoke_success';
var APPLICATION_REVOKE_FAIL = 'ms/application/revoke_fail';

var APPLICATION_AUTH_LOAD = 'ms/application/auth_load';
var APPLICATION_AUTH_LOAD_SUCCESS = 'ms/application/auth_load_success';
var APPLICATION_AUTH_LOAD_FAIL = 'ms/application/auth_load_fail';

var initialState = {
  applications: {
    loading: false,
    loaded: false,
    loadingError: false,
    applications: []
  },

  application: {
    creating: false,
    created: false,
    creatingError: null,

    deleting: false,
    deleted: false,
    deletingError: null,

    revoking: false,
    revoked: false,
    revokingError: null
  },

  authorizedApplications: {
    loading: false,
    loaded: false,
    loadingError: null,
    applications: []
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case APPLICATION_CREATE_INIT:
      {
        return (0, _extends3.default)({}, state, {

          application: (0, _extends3.default)({}, state.application, {

            creating: false,
            created: false,
            creatingError: null
          })
        });
      }

    case APPLICATION_CREATE:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          creating: true,
          created: false,
          creatingError: null
        })
      });

    case APPLICATION_CREATE_SUCCESS:

      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          creating: false,
          created: true,
          creatingError: null
        }),

        applications: (0, _extends3.default)({}, state.applications, {

          applications: state.applications.applications.concat(action.result)
        })
      });

    case APPLICATION_CREATE_FAIL:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          creating: false,
          created: false,
          creatingError: action.error
        })
      });

    case APPLICATION_LOAD_ALL:
      return (0, _extends3.default)({}, state, {

        applications: {
          loading: true,
          loaded: false,
          loadingError: null,
          applications: []
        }
      });

    case APPLICATION_LOAD_ALL_SUCCESS:
      return (0, _extends3.default)({}, state, {

        applications: {
          loading: false,
          loaded: true,
          loadingError: null,
          applications: action.result.applications
        }
      });

    case APPLICATION_LOAD_ALL_FAIL:
      return (0, _extends3.default)({}, state, {

        applications: {
          loading: false,
          loaded: false,
          loadingError: action.error,
          applications: []
        }
      });

    case APPLICATION_DELETE:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          deleting: true,
          deleted: false,
          deletingError: null
        })
      });

    case APPLICATION_DELETE_FAIL:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          deleting: false,
          deleted: false,
          deletingError: action.error
        })
      });

    case APPLICATION_DELETE_SUCCESS:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          deleting: false,
          deleted: true,
          deletingError: null
        }),

        applications: (0, _extends3.default)({}, state.applications, {

          applications: state.applications.applications.filter(function (app) {
            return app.id !== action.result.id;
          })
        })
      });

    case APPLICATION_REVOKE:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          revoking: true,
          revoked: false,
          revokingError: null
        })
      });
    case APPLICATION_REVOKE_FAIL:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          revoking: false,
          revoked: false,
          revokingError: action.error
        })
      });
    case APPLICATION_REVOKE_SUCCESS:
      return (0, _extends3.default)({}, state, {

        application: (0, _extends3.default)({}, state.application, {

          revoking: false,
          revoked: true,
          revokingError: null
        }),

        authorizedApplications: (0, _extends3.default)({}, state.authorizedApplications, {

          applications: state.authorizedApplications.applications.filter(function (app) {
            return app.id !== action.result.id;
          })
        })
      });

    case APPLICATION_AUTH_LOAD:
      return (0, _extends3.default)({}, state, {

        authorizedApplications: (0, _extends3.default)({}, state.authorizedApplications, {

          loading: true,
          loaded: false,
          loadingError: null
        })
      });

    case APPLICATION_AUTH_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {

        authorizedApplications: (0, _extends3.default)({}, state.authorizedApplications, {

          loading: false,
          loaded: true,
          loadingError: null,
          applications: action.result.sessions
        })
      });

    case APPLICATION_AUTH_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {

        authorizedApplications: (0, _extends3.default)({}, state.authorizedApplications, {

          loading: false,
          loaded: false,
          loadingError: action.error
        })
      });

    default:
      return state;
  }
}

// Action creators
function resetCreateApplication() {
  return {
    type: APPLICATION_CREATE_INIT
  };
}

// app: { name, icon, company, description }
function createApplication(app) {

  return {
    types: [APPLICATION_CREATE, APPLICATION_CREATE_SUCCESS, APPLICATION_CREATE_FAIL],
    promise: function promise(client) {
      return client.post('sso://v1/applications', { data: app });
    }
  };
}

function loadApplications() {
  return {
    types: [APPLICATION_LOAD_ALL, APPLICATION_LOAD_ALL_SUCCESS, APPLICATION_LOAD_ALL_FAIL],
    promise: function promise(client) {
      return client.get('sso://v1/applications');
    }
  };
}

function loadApplication(appID) {
  return {
    types: [APPLICATION_LOAD, APPLICATION_LOAD_SUCCESS, APPLICATION_LOAD_FAIL],
    promise: function promise(client) {
      return client.get('sso://v1/applications/' + appID);
    }
  };
}

function deleteApplication(appID) {
  return {
    types: [APPLICATION_DELETE, APPLICATION_DELETE_SUCCESS, APPLICATION_DELETE_FAIL],
    promise: function promise(client) {
      return client.delete('sso://v1/applications/' + appID);
    }
  };
}

function loadAuthorisedApplications() {
  return {
    types: [APPLICATION_AUTH_LOAD, APPLICATION_AUTH_LOAD_SUCCESS, APPLICATION_AUTH_LOAD_FAIL],
    promise: function promise(client) {
      return client.get('sso://v1/applications/sessions');
    }
  };
}

function revokeApplication(sessionID) {
  return {
    types: [APPLICATION_REVOKE, APPLICATION_REVOKE_SUCCESS, APPLICATION_REVOKE_FAIL],
    promise: function promise(client) {
      return client.delete('sso://v1/applications/sessions/' + sessionID).then(function (res) {
        return {
          id: sessionID
        };
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/applications.js
// module id = 271
// module chunks = 0